import { MsgData } from './../../protobuf/msg';
import { AckMsg } from './../../protobuf/ack';
import { ByteUtil, GuidUtil } from './../../utils/index';
import { Constant } from './../../utils/constant';
import AckStore from './ackStore';
import { EventBus } from './../eventBus/eventBus';
import { PullRequest } from './../../protobuf/pullMsg';
import commonBiz from '../../domain/common/commonBiz';
export default class MsgBiz {
    static sendP2PMsg(clientStater, guid, fromGuid, targetGuid, msg, contentType, sender, extension) {
        let _msg = this.buildMsg(guid, fromGuid, targetGuid, msg, MsgData.SessionType.P2P, contentType, sender, extension);
        let _ack = this.buildAck(guid, fromGuid, targetGuid, guid, AckMsg.MsgAckType.CLIENT_SEND_OK);
        return this.sendMsg(clientStater, _msg, _ack);
    }
    //发送消息
    static sendMsg(clientStater, msg, ack) {
        return new Promise((rolsve, reject) => {
            let _msgByte = this.encodeMsg(msg);
            let _ackByte = this.encodeAck(ack);
            // this.encodeAck(ack);
            clientStater.send(_msgByte);
            //存入ack队列
            AckStore.createOrUpdate(ack);
            clientStater.send(_ackByte);
            setTimeout(() => {
                this.retryMsg(clientStater, msg, ack, 3);
            }, 3000);
            EventBus.on(ack.guid, (res) => {
                if (res.code == 200) {
                    rolsve(res);
                }
                else {
                    reject(res);
                }
            });
        });
    }
    static sendAck(clientStater, guid, fromGuid, targetGuid, refGuid, ackMsgType) {
        let _ack = this.buildAck(guid, fromGuid, targetGuid, refGuid, ackMsgType);
        //建立ack 添加到 ack队列中
        AckStore.createOrUpdate(_ack);
        clientStater.send(this.encodeAck(_ack));
    }
    static retryMsg(clientStater, msg, ack, times) {
        let _ack = AckStore.get(ack.guid);
        if (times > 0) {
            //如果
            if (parseInt(_ack.ackState) <= parseInt(AckMsg.MsgAckType.CLIENT_SEND_OK)) {
                setTimeout(() => {
                    this.retryMsg(clientStater, msg, ack, times - 1);
                }, 3000);
            }
        }
        else {
            let _ack = AckStore.get(ack.guid);
            if (parseInt(_ack.ackState) <= parseInt(AckMsg.MsgAckType.CLIENT_SEND_OK)) {
                clientStater.dispatch(ack.guid, { code: 502, data: '消息发送超时' + JSON.stringify(_ack) });
                AckStore.remove(ack.guid);
            }
            //超时服务器人没有收到
        }
    }
    static retryAck(clientStater, ack, times) {
        let _ack = AckStore.get(ack.guid);
        if (times > 0) {
            //如果ack状态没变
            if (parseInt(_ack.ackState) <= parseInt(AckMsg.MsgAckType.CLIENT_TO_FORWARD)) {
                //重发ack
                clientStater.send(this.encodeAck(ack));
                setTimeout(() => {
                    this.retryAck(clientStater, ack, times - 1);
                }, 3000);
            }
            else {
                //todo 删除msg
                AckStore.remove(ack.guid);
            }
        }
        else {
            if (parseInt(_ack.ackState) <= parseInt(AckMsg.MsgAckType.CLIENT_TO_FORWARD)) {
                clientStater.dispatch(ack.guid, { code: 502, data: '消息发送超时' + JSON.stringify(_ack) });
                AckStore.remove(ack.guid);
            }
            //超时服务器人没有收到
        }
    }
    static getMsgBuffer(clientStater, fromGuid) {
        return new Promise((reslove, reject) => {
            let _guid = GuidUtil.nextId();
            var _historyMsg = {
                // 协议参数
                guid: _guid,
                version: 1,
                fromGuid: fromGuid,
                pullType: PullRequest.PullType.MSGBUFFER
            };
            //编码
            let utf8 = PullRequest.encode(_historyMsg).finish();
            let sendByte = ByteUtil.unionUint8Array([
                ByteUtil.intArrToBytes([utf8.length, Constant.SendType.PULL]),
                utf8
            ]);
            // 返回数据
            return commonBiz.pullResponseOperate(clientStater, sendByte, _guid).then(res => {
                reslove(res);
            }).catch(error => {
                reject(error);
            });
        });
    }
    static buildMsg(guid, fromGuid, targetGuid, msg, sessionType, contentType, sender, extension) {
        var _msg = {
            version: 0,
            guid: guid,
            fromGuid: fromGuid,
            targetGuid: targetGuid,
            time: new Date().getTime(),
            data: msg,
            sessionType: sessionType,
            contentType: contentType,
            sender: sender,
            extension: extension
        };
        return _msg;
    }
    static buildAck(guid, fromGuid, targetGuid, refGuid, ackMsgType) {
        var _ack = {
            version: 1,
            fromGuid: fromGuid,
            targetGuid: targetGuid,
            refGuid: refGuid,
            guid: guid,
            ackState: ackMsgType,
        };
        return _ack;
    }
    static encodeAck(ack) {
        let utf8 = AckMsg.encode(ack).finish();
        let sendByte = ByteUtil.unionUint8Array([
            ByteUtil.intArrToBytes([utf8.length, Constant.SendType.ACK]),
            utf8
        ]);
        return sendByte;
    }
    static encodeMsg(msg) {
        //编码
        let utf8 = MsgData.encode(msg).finish();
        let sendByte = ByteUtil.unionUint8Array([
            ByteUtil.intArrToBytes([utf8.length, Constant.SendType.MSG]),
            utf8
        ]);
        return sendByte;
    }
}
//# sourceMappingURL=msgBiz.js.map
